import React from "react";
import { View, Text, Button, Icon } from "ui";
import { styled, theme } from "styles";
import { MemoPhoto, Memo } from "types";
import _ from "lodash";
import { photoMutations } from "api";
import Dialog from "@material-ui/core/Dialog";
import axios from "axios";
import fileDownload from "js-file-download";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { space, SpaceProps } from "styled-system";
import AddPicture from "./AddPicture";
import ConfirmDialog from "./ConfirmDialog";
import { notify } from "../shared/services/notify";

interface P {
  photos: MemoPhoto[];
  memo: Memo;
  onClick?: (photo: MemoPhoto) => void;
}
export default class PicturesList extends React.Component<P> {
  public state = {
    selectedPhotoIndex: undefined,
    photoLink: undefined,
    openDialog: false
  };

  public slickSlider = React.createRef<Slider>();

  public getBase64 = file => {
    return new Promise<string>((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (reader.result instanceof ArrayBuffer) {
          resolve("");
        } else {
          resolve(reader.result);
        }
      };
      reader.onerror = error => {
        reject(error);
      };
    });
  }
  public handlePhotoClose = () =>
    this.setState({ selectedPhotoIndex: undefined })

  public downloadPic = () => {
    axios
      .get(this.state.photoLink, {
        responseType: "blob"
      })
      .then(res => {
        fileDownload(res.data, this.state.selectedPhotoIndex + ".jpg");
      });
  }

  public handlePhotoSelect = photo => {
    this.setState({
      selectedPhotoIndex: photo.index,
      photoLink: photo.uri
    });
  }

  public deleteItem = photo => {
    const { openDialog } = this.state;
    return (
      <photoMutations.DeletePhoto>
        {deletePhoto => (
          <ConfirmDialog
            text="Esti sigur ca vrei sa stergi poza?"
            open={openDialog}
            onClose={() => this.setState({ openDialog: false })}
            onConfirm={async () => {
              try {
                const { id } = photo;

                await deletePhoto({ variables: { id } });
                this.setState({ selectedPhotoIndex: undefined, openDialog: false });
                notify("Poza a fost stearsa!");
              } catch (err) {}
            }}
          />
        )}
      </photoMutations.DeletePhoto>
    );
  }

  public handleNext = () => {
    this.slickSlider.current.slickNext();
  }

  public handlePrevious = () => {
    this.slickSlider.current.slickPrev();
  }

  public handlePrevModal = () => {
    const { memo, photos } = this.props;
    const { selectedPhotoIndex, photoLink } = this.state;
    const id = selectedPhotoIndex - 1;
    const photo = photos[id];

    if (photo) {
      this.setState({ selectedPhotoIndex: id, photoLink: photo.uri });
    }
  }

  public handleNextModal = () => {
    const { memo, photos } = this.props;
    const { selectedPhotoIndex } = this.state;
    const id = selectedPhotoIndex + 1;
    const photo = photos[id];
    if (photo) {
      this.setState({ selectedPhotoIndex: id, photoLink: photo.uri });
    }
  }

  public renderPhotoModal = (memo: Memo, photos: MemoPhoto[]) => {
    const { selectedPhotoIndex, openDialog } = this.state;
    const photo = photos[selectedPhotoIndex];

    if (!photo) {
      return null;
    }
    return (
      <Dialog open={!!photo} onClose={this.handlePhotoClose} scroll="body">
        <View
          p={2}
          bg="#FFFFFF"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <ExitPhoto onClick={this.handlePhotoClose}>
            <Icon name="close-circle" size={2.5} color={theme.colors.primary} />
          </ExitPhoto>
          <View
            alignItems="center"
            justifyContent="space-between"
            flexDirection="row"
          >
            <ArrowLeft onClick={this.handlePrevModal}>
              <Icon
                name="arrow-left-circle"
                size={2}
                color={theme.colors.primary}
              />
            </ArrowLeft>
            <Photo src={photo.uri} />
            <ArrowRight onClick={this.handleNextModal}>
              <Icon
                name="arrow-right-circle"
                size={2}
                color={theme.colors.primary}
              />
            </ArrowRight>
          </View>
          <View mt={1} flexDirection="row">
            <Button
              bg="red"
              mr={4}
              onClick={() => this.setState({ openDialog: true })}
            >
              <Text fontWeight="bold" fontSize={3} color="white">
                Sterge
              </Text>
            </Button>
            {openDialog && this.deleteItem(photo)}
            <Button bg="primary" onClick={this.downloadPic}>
              <Text fontWeight="bold" fontSize={3} color="white">
                Descarca
              </Text>
            </Button>
          </View>
        </View>
      </Dialog>
    );
  }

  public render = () => {
    const { photos, memo } = this.props;
    let { selectedPhotoIndex } = this.state;

    return (
      <View bg="transparent" flexDirection="row" justifyContent="center" mb={3}>
        <StyledSlider
          ref={this.slickSlider as any}
          infinite={false}
          speed={500}
          slidesToShow={3}
          slidesToScroll={3}
          nextArrow={
            <span>
              <Icon
                name="arrow-right-circle"
                size={1.5}
                color={theme.colors.primary}
              />
            </span>
          }
          prevArrow={
            <span>
              <Icon
                name="arrow-left-circle"
                size={1.5}
                color={theme.colors.primary}
              />
            </span>
          }
          adaptiveHeight
          draggable={false}
        >
          {photos.map((picture, index) => (
            <View>
              <View flexDirection="row" justifyContent="center">
                <Image
                  src={picture.uri}
                  onClick={() => {
                    this.setState({
                      selectedPhotoIndex: index,
                      photoLink: picture.uri
                    });
                  }}
                />
              </View>
            </View>
          ))}
          {photos.length === 0 && <AddPicture photos={photos} memo={memo} />}
          {photos.length === 0 && <AddPicture photos={photos} memo={memo} />}
          {photos.length === 1 && <AddPicture photos={photos} memo={memo} />}
          <AddPicture photos={photos} memo={memo} />
        </StyledSlider>
        {selectedPhotoIndex !== undefined &&
          this.renderPhotoModal(memo, photos)}
      </View>
    );
  }
}

const Image = styled.img<SpaceProps>`
  height: 6rem;
  width: 6rem;
  cursor: pointer;
  object-fit: cover;
  ${space}
`;

const Photo = styled.img`
  width: 80%;
  height: 80%;
`;

const ExitPhoto = styled(View)`
  display: flex;
  align-self: flex-end;
  cursor: pointer;
  margin-bottom: 1rem;
`;
const ArrowRight = styled(View)`
  color: #f16541 !important;
  cursor: pointer;
`;
const ArrowLeft = styled(View)`
  color: #f16541 !important;
  cursor: pointer;
`;

const StyledSlider = styled(Slider)`
  max-width: 35rem;
  width: 27rem;
  height: 7rem;
`;



// WEBPACK FOOTER //
// ./src/components/PicturesList.tsx